import Icon from "./Icons";

/**
 * Shared CTA button. Renders an <a> when `href` is given, otherwise a
 * <button>. Variants: primary | secondary | outline. Set `arrow` to append
 * the arrow-right glyph.
 */
export function Button({
  href,
  variant = "primary",
  size,
  arrow = false,
  className = "",
  children,
  onClick,
  type = "button",
  target,
  rel,
  ...rest
}) {
  const classes = ["btn", `btn-${variant}`, size === "sm" ? "btn-sm" : "", className]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      <span>{children}</span>
      {arrow ? <Icon name="arrowRight" size={18} /> : null}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick} target={target} rel={rel} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick} {...rest}>
      {content}
    </button>
  );
}

export default Button;
